import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import InputContainer from "../../components/InputContainer/index";
import { getCategoriesAction } from "../../store/actions/categories";

const validationSchema = yup.object({});

const Information = ({ next, values }) => {
  const dispatch = useDispatch();

  const categories = useSelector((s) => s?.categories?.data);
  const loading = useSelector((s) => s?.categories?.loading);
  const fetchCategories = useCallback(
    (page = 1) => {
      getCategoriesAction({ page })(dispatch);
    },
    [dispatch]
  );

  useEffect(() => fetchCategories(), [fetchCategories]);

  const formik = useFormik({
    initialValues: {
      name: values?.name || "",
      description: values?.description || "",
      categoryIds: values?.categoryIds || [],
    },

    validationSchema: validationSchema,
    onSubmit: (vals) => {
      next({
        ...vals,
      });
    },
  });
  return (
    <>
      <Box sx={{ width: 1 }}>
        <Box
          sx={{
            bgcolor: "#F8F8F8",
            px: 2,
            py: 1,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderRadius: 3,
          }}
        >
          <Typography variant="body1" color={"#323232"}>
            1. Information
          </Typography>
        </Box>
        <form onSubmit={formik.handleSubmit} style={{ width: "100%" }}>
          <InputContainer title={"Video Name"} sx={{ my: 1 }}>
            <TextField
              fullWidth
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              placeholder={"Enter Video Name"}
              variant="standard"
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
              InputProps={{
                disableUnderline: true,
              }}
            />
          </InputContainer>
          <InputContainer title={"Details"} sx={{ my: 1 }}>
            <TextField
              fullWidth
              name="description"
              value={formik.values.description}
              onChange={formik.handleChange}
              placeholder={"Enter Details"}
              variant="standard"
              error={
                formik.touched.description && Boolean(formik.errors.description)
              }
              helperText={
                formik.touched.description && formik.errors.description
              }
              InputProps={{
                disableUnderline: true,
              }}
            />
          </InputContainer>
          <InputContainer title={"Category"} sx={{ my: 1 }}>
            <Select
              multiple
              fullWidth
              size="small"
              variant="standard"
              id="categoryIds"
              name="categoryIds"
              value={formik.values.categoryIds}
              MenuProps={{ PaperProps: { sx: { maxHeight: "300px" } } }}
              renderValue={
                formik.values.categoryIds.length !== 0
                  ? () => (
                      <Typography color="text.green">{`category (${formik.values.categoryIds.length})`}</Typography>
                    )
                  : () => (
                      <Typography variant="subtitle1" color="text.disabled">
                        choose category
                      </Typography>
                    )
              }
              displayEmpty
              onChange={(e) => {
                formik.handleChange(e);
              }}
              error={
                formik.touched.categoryIds && Boolean(formik.errors.categoryIds)
              }
              helperText={
                formik.touched.categoryIds && formik.errors.categoryIds
              }
              sx={{
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "2px solid #F6F6F6",
                },
                backgroundColor: "white",
              }}
            >
              {categories.map((e, i) => (
                <MenuItem key={i} value={e?.id}>
                  <Checkbox
                    color="success"
                    checked={formik.values.categoryIds.indexOf(e?.id) > -1}
                  />
                  <ListItemText primary={e?.name} />
                </MenuItem>
              ))}
              {loading && (
                <MenuItem>
                  <CircularProgress size={20} sx={{ margin: "auto" }} />
                </MenuItem>
              )}
            </Select>
          </InputContainer>
          <Box sx={{ backgroundColor: "#fff", width: 1, mt: 2 }}>
            <Button
              type="submit"
              sx={{ p: 1, width: "20%" }}
              variant="contained"
              color="error"
            >
              <Typography color={"white"}>Next</Typography>
            </Button>
          </Box>
        </form>

        <Box
          sx={{
            bgcolor: "#F8F8F8",
            px: 2,
            py: 1,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            my: 2,
            borderRadius: 3,
          }}
        >
          <Typography variant="body1" color={"#323232"}>
            2. Interactive settings
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default Information;
